import React , {Component, Fragment} from 'react'

class FileUploader extends Component {

    state = {};
    route = "http://79.175.176.98:9012/api/FileUpload/UploadFiles";

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    fileChangedHandler = event => {
        this.setState({
            selectedFile: event.target.files[0]
        });

        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                imagePreviewUrl: reader.result
            });
        };

        reader.readAsDataURL(event.target.files[0]);
        this.submit(event.target.files[0]);
    };

    submit = (file) => {
        let fd = new FormData();

        fd.append('formFile', file);

        let request = new XMLHttpRequest();
        const comp = this;

        request.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                const response = JSON.parse(this.response);
                console.log('response: ', response);
                if (response.isSuccess) {
                    comp.props.onChange(Number(response.data))
                }
            }
        };
        request.open("POST", this.route, true);
        request.send(fd);
    };

    render() {
        let $imagePreview = null;

        if (this.state.imagePreviewUrl) {
            $imagePreview = (
                <div className="image-container" >
                    <img src={this.state.imagePreviewUrl} />
                    {/*<button type="button" onClick={this.submit} > Upload </button>*/}
                </div>
                );
        }

        return (
            <div className="organizer fileUploadWrapper">
                <label for="imageupload" className="normalButton fillMode originalButton" >
                    <span className="icon icon-upload font-size_18 middleContext"></span> آپلود عکس
                </label>
                <input type="file" id="imageupload" className="tempDisable" onChange={this.fileChangedHandler} />
                { $imagePreview }
            </div>
        )
    }
}

export default FileUploader;